import React from 'react';
import { LeafIcon } from 'lucide-react';
import { PRODUCT } from '../data/content';
export function SiteFooter() {
  return <footer className="border-t border-ink-700/60 bg-ink-900 py-8" style={{
    paddingTop: "36px"
  }} data-id="element-162" data-mp="3r9kf72sw1r4w">
      <div className="mx-auto max-w-content px-5 text-center" data-id="element-163" data-mp="3mg83ft9b5etk">
        <p className="inline-flex items-center gap-2 text-base font-extrabold uppercase tracking-[0.2em] text-lime-400" data-id="element-164" data-mp="3hizm1uvzhetd">
          <LeafIcon className="h-4 w-4" aria-hidden="true" data-id="element-165" data-mp="3dhw4n3yafaq1" />
          {PRODUCT.brand}
        </p>
        <p className="mt-2 text-sm font-semibold text-white/70" data-id="element-166" data-mp="38gqbj50ptlfz">
          Your body is not broken. It just needs the right map.
        </p>

        <p className="mt-3 flex flex-wrap items-center justify-center gap-x-4 gap-y-1.5 text-sm text-white/50" data-id="element-167" data-mp="33krjn7g6hlat">
          <a href={`mailto:${PRODUCT.email}`} className="transition-colors duration-150 ease-out hover:text-lime-400" data-id="element-168" data-mp="11rbqa2sphsc5">
            📧 {PRODUCT.email}
          </a>
          <a href={`https://${PRODUCT.site}`} className="transition-colors duration-150 ease-out hover:text-lime-400" data-id="element-169" data-mp="wsqnpwpzewkj">
            🌐 {PRODUCT.site}
          </a>
        </p>

        <p className="mx-auto mt-4 max-w-2xl text-xs leading-relaxed text-white/35" data-id="element-170" data-mp="1aqzqmvhspo82">
          © {PRODUCT.brand} 2026 — All rights reserved. Educational content. Does not replace
          professional medical consultation.
        </p>
        <p className="mt-3 text-sm font-bold text-white/60" data-id="element-171" data-mp="10s0ozwvg6suk">
          🌿 “Stop massaging the echo. Fix the source.”
        </p>
      </div>
    </footer>;
}